/** Top-level store nav / hero roots (must match DB slugs). Order = display order (LTR). */
export const STORE_MAIN_ROOT_SLUGS = [
  "furniture",
  "doors",
  "kitchens",
  "decor-accessories",
  "outdoor",
  "curtains",
];
